<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2021-10-12 09:47:12
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-03-20 09:57:33
-->
<template>
  <div v-loading="loading">
    <div class="maintitle">{{$route.meta.title}}</div>
    <el-divider></el-divider>
    <div class="text-left">
        <li v-for='(item,index) in list' :index='index' :key='index' class="margin-bottom">
          <div style="font-weight: bold;">{{item.name}}</div>
          <span v-for="(it,ind) in item.list" :key="ind" style="margin-right:10px;white-space: nowrap;color:gray">{{it}}</span>  
        </li>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list:[],
    };
  },
  computed: {},
  methods: {
    getlist() {
      this.$axios({
        url: this.HOST + "/kaohe/vote/getVotingList",
        method: "post",
        data: {},
      }).then((res) => {
        this.list = res.data.list;
      });
    },
  },
  created: function () {
    this.getlist();
  },
};
</script>